// extracted by mini-css-extract-plugin
export default {"root":"root--ZnTP4","img":"img--E5rCi","video":"video--ocAk3","imageMirror":"imageMirror--a7I_u","invis":"invis--lYNXg"};